import axios from 'axios';
import { API_BASE_URL } from './url_config';

export const fetchEnquries = async (data, token) => {
  return await axios.post(`${API_BASE_URL}/enquiry/list`, data, {
    headers: {
        Authorization: `Bearer ${token}`,
    }
  });
};

export const deleteEnquries = async (data, token) => {
  return await axios.put(`${API_BASE_URL}/enquiry/delete`, data, {
    headers: {
        Authorization: `Bearer ${token.token}`,
    }
  });
};